// Tab dei tre canali della sezione TV & Media in home (Rassegna stampa, Podcast,
// Programmi TV): un solo pannello visibile alla volta. Markup e attributi aria
// generati da template-parts/home/tv-media.php seguono già il pattern WAI-ARIA
// "Tabs" (freccia sinistra/destra per spostare il focus tra i tab, Home/End per
// il primo/ultimo); qui applichiamo solo il comportamento.

function activateTab( tabs, panels, index ) {
    tabs.forEach( ( tab, i ) => {
        const isActive = i === index;
        tab.classList.toggle( 'is-active', isActive );
        tab.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
        tab.tabIndex = isActive ? 0 : -1;
    } );

    panels.forEach( ( panel, i ) => {
        const isActive = i === index;
        panel.classList.toggle( 'is-active', isActive );
        panel.hidden = ! isActive;
    } );
}

export function initTvMediaTabs() {
    document.querySelectorAll( '[data-tv-media-tabs]' ).forEach( ( container ) => {
        const tabs = Array.from( container.querySelectorAll( '[role="tab"]' ) );
        const panels = Array.from( container.querySelectorAll( '[role="tabpanel"]' ) );

        if ( ! tabs.length ) {
            return;
        }

        tabs.forEach( ( tab, index ) => {
            tab.addEventListener( 'click', () => activateTab( tabs, panels, index ) );

            tab.addEventListener( 'keydown', ( event ) => {
                let nextIndex = null;

                if ( 'ArrowRight' === event.key ) {
                    nextIndex = ( index + 1 ) % tabs.length;
                } else if ( 'ArrowLeft' === event.key ) {
                    nextIndex = ( index - 1 + tabs.length ) % tabs.length;
                } else if ( 'Home' === event.key ) {
                    nextIndex = 0;
                } else if ( 'End' === event.key ) {
                    nextIndex = tabs.length - 1;
                }

                if ( null === nextIndex ) {
                    return;
                }

                event.preventDefault();
                activateTab( tabs, panels, nextIndex );
                tabs[ nextIndex ].focus();
            } );
        } );
    } );
}
